import {useCurrencyStore} from '@store/CurrencyStore'
import {useTranslation} from '@lib/intl/useTranslations'
import {shallow} from 'zustand/shallow'
import {equalString} from '@util/strings'
import {useCallback, useMemo} from 'react'
import {createLog} from '@util/logs'
import {setUserProperty} from '@util/amplitude'

const useChangeCurrency = () => {
    const t = useTranslation()
    const {currencies, changeCurrency, selectedSymbol} = useCurrencyStore(state => state, shallow)

    const options = useMemo(() => {
        return currencies?.map(currency => {
            return {
                id: currency?.symbol,
                title: t(`globalNavigation.currency.menu.${currency?.symbol?.toLowerCase()}`),
                onClick: () => {
                    createLog('event', 'navigation_change_currency', {currency: currency?.symbol})
                    setUserProperty('currency', currency?.symbol)
                    changeCurrency(currency?.symbol)
                },
            }
        })
    }, [t, changeCurrency])

    const getCurrentCurrencyOption = useCallback(
        () => options?.find(item => equalString(item?.id, selectedSymbol)),
        [options, selectedSymbol],
    )

    return {options, selectedSymbol, getCurrentCurrencyOption}
}

export default useChangeCurrency
